import { API_v2 } from '@/services/config';
import { request } from '@@/exports';

/**
 * 获取存在绑定关系的用户列表( 授权 )
 * @param params
 * @param options
 */
export async function getUserPlatformRelationsByUser(
  params: {
    page?: number;
    pageSize?: number;
    query_all?: number;
    id: number | string;
    platform_id: number | string;
  },
  options?: { [key: string]: any },
) {
  // 执行实际的 API 请求
  return request(API_v2.getUserPlatformRelationsByUser, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
    params,
    ...(options || {}),
  });
}

/**
 * 获取绑定关系的平台列表 ( 公司或项目 )( 授权 )
 * @param params
 * @param options
 */
export async function getUserPlatformRelationsByPlatform(
  params: {
    page?: number;
    pageSize?: number;
    query_all?: number;
    admin_id?: number | string;
    platform_id: number | string;
    company_id?: number | string; // 存在则查询公司下项目,否则查询全部项目
  },
  options?: { [key: string]: any },
) {
  // 执行实际的 API 请求
  return request(API_v2.getUserPlatformRelationsByPlatform, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
    params,
    ...(options || {}),
  });
}

/**
 * 写入绑定关系 ( 权限 )
 * @param data
 * @param options
 */
export async function setRelations(
  data: {
    relations: {
      admin_id?: number;
      platform_id?: number;
      platform_entity_id?: number;
    };
    ids: number[];
    type: string;
  },
  options?: { [key: string]: any },
) {
  // 执行实际的 API 请求
  return request(API_v2.setRelations, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
    ...(options || {}),
  });
}
/**
 * 将绑定关系与角色关联 (用户与 [公司/项目]的绑定关系)
 * @param data
 * @param options
 */
export async function setRoleRelations(
  data: {
    relation_id: number;
    roles: number[];
    type: 'user' | 'platform';
  },
  options?: { [key: string]: any },
) {
  // 执行实际的 API 请求
  return request(API_v2.setRoleRelations, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
    ...(options || {}),
  });
}
/**
 * 批量 将绑定关系与角色关联 (用户与 [公司/项目]的绑定关系)
 * @param data
 * @param options
 */
export async function setRoleRelationAll(
  data: {
    admin_id?: number;
    platform_id?: number;
    platform_entity_id?: number;
    relation_id: number;
  },
  options?: { [key: string]: any },
) {
  // 执行实际的 API 请求
  return request(API_v2.setRoleRelationAll, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
    ...(options || {}),
  });
}

/**
 * 保存自动授权项目 (用户与项目的绑定关系)
 * @param data
 * @param options
 */
export async function saveAutoAuthProjectByUser(
  data: {
    type: string,
    users: Array<number>, // 只包含用户 ID 数组
    roles: Array<number>,
    syncExisting: boolean,
    platformId: number
  },
  options?: { [key: string]: any },
) {
  // 执行实际的 API 请求
  return request(API_v2.saveAutoAuthProjectByUser, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
    ...(options || {}),
  });
}
/**
 * 保存自动授权公司 (用户与公司的绑定关系)
 * @param data
 * @param options
 */
export async function saveAutoAuthCompanyByUser(
  data: {
    type: string,
    users: Array<number>, // 只包含用户 ID 数组
    roles: Array<number>,
    syncExisting: boolean,
    platformId: number
  },
  options?: { [key: string]: any },
) {
  // 执行实际的 API 请求
  return request(API_v2.saveAutoAuthCompanyByUser, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
    ...(options || {}),
  });
}
/**
 * 获取用户自动授权公司
 * @param params
 * @param options
 */
export async function getAutoAuthByUser(
  params: {
    admin_id?: number | string;
    auth_type?: number | string;
  },
  options?: { [key: string]: any },
) {
  // 执行实际的 API 请求
  return request(API_v2.getAutoAuthByUser, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
    params,
    ...(options || {}),
  });
}